import { render } from "./ProgressEvaluationTable.vue?vue&type=template&id=1571d63c"
import script from "./ProgressEvaluationTable.vue?vue&type=script&lang=js"
export * from "./ProgressEvaluationTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__